import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { catchError, throwError } from 'rxjs';
import { AuthService } from '../services/auth.service';
import { DeviceService } from '../services/device.service';

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const auth = inject(AuthService);
  const device = inject(DeviceService);
  const token = auth.getToken();

  const headers: Record<string, string> = {
    ...device.getRequestHeaders(),
  };
  if (token) {
    headers['x-access-token'] = token;
  }

  const authReq = req.clone({ setHeaders: headers });

  return next(authReq).pipe(
    catchError((err: unknown) => {
      if (err instanceof HttpErrorResponse && (err.status === 401 || err.status === 403)) {
        const isAuthEndpoint =
          req.url.includes('/admin/auth/signIn') || req.url.includes('/admin/auth/verifyOTP');
        if (!isAuthEndpoint && auth.isAuthenticated()) {
          auth.logout();
        }
      }
      return throwError(() => err);
    })
  );
};
